import React, {useEffect, useState} from 'react';
import {
    getBackgroundImg,
    getUploadedImagePath,
    notifyError,
    useAppDispatch,
    useAppState, useBreakpoints
} from '@nutastic/nutastic-react-app';
import TabSlider, { TabSliderContent } from '../../refactor/tabs/TabSlider';
import {useParams} from "react-router-dom";
import {CONSTANTS} from "../../utils/constants";
import {WebsiteActions} from "../../state/actions.mjs";
import ContentTrackList from "../ContentTrackList";
import {ContentDescription} from "../ContentDetails";
import ContentNotFoundPage from "./ContentNotFoundPage";
import makeFetchCall from "../../utils/makeFetchCall";
import buildTracks from "../../refactor/nu-player/utils/buildTracks.mjs";
import {useNuPlayerContext} from "../../refactor/nu-player/NuPlayerContext";
import {useNavigation} from "../../hooks/useNavigation";

const componentClass = 'contentPage';

const ContentMusicPage = () => {
    const appDispatch = useAppDispatch();
    const { loadPage } = useNavigation();
    const { lg: isLargeScreen } = useBreakpoints();
    const { insertDiscAndPressPlay } = useNuPlayerContext();
    const {
        isProcessing,
        content: {
            audioSeries = []
        }
    } = useAppState();
    const [currentSeries, setCurrentSeries] = useState(null);
    const [activeTab, setActiveTab] = useState(0);
    const { id: seriesSlug } = useParams();

    const {
        title: seriesTitle,
        shortDescription,
        description,
        image: seriesImage,
        poster,
        thumbnail,
        tracks,
        isPlaylist
    } = currentSeries || {};

    useEffect(() => {
        setCurrentSeries(null);
        const fetchSeriesContent = async () => {
            appDispatch({ type: WebsiteActions.REUP_STARTED });
            try {
                const seriesToSet = audioSeries.find(s => s?.slug === seriesSlug);
                if(seriesToSet) {
                    const seriesList = await makeFetchCall(`/api/load-music/${seriesToSet.id}`);
                    if (seriesList) setCurrentSeries({...seriesList});
                }
            } catch (e) {
                notifyError('loadSeriesError', 'Yoooooo', 'You may not have enough waves to connect with this content. Try again later...');
            }
            setTimeout(() => {
                appDispatch({ type: WebsiteActions.REUP_DONE });
            }, 1000);
        }
        // noinspection JSIgnoredPromiseFromCall
        fetchSeriesContent();
    }, [seriesSlug]);

    const onPressPlay = (trackIndex, setIndex) => {
        const trackListToUse = tracks[setIndex || 0];
        const tracksToLoad = buildTracks(trackListToUse?.tracks, thumbnail || seriesImage);
        insertDiscAndPressPlay({tracksToLoad, trackIndex: trackIndex || 0});
    };

    const buildTabs = () => {
        const relatedTab = {
            label: 'Related',
            key: 1,
            children: <ContentDescription className="extraMargin" description={"Related content will be shown here. This section is currently under construction, we shall be ready sooner than later..."}
            />
        };
        const trackList = {
            label: 'Details',
            key: 0,
            children: <React.Fragment>
                { description && <ContentDescription description={description} /> }
                { description && <hr className="contentInfoHr" /> }
                <ContentTrackList trackSets={tracks} onClick={onPressPlay} shouldRenderDetails={!isPlaylist}/>
            </React.Fragment>
        }

        return [trackList, relatedTab];
    }

    return (!isProcessing && currentSeries) ? <article className={componentClass}>
        <div className={`${componentClass}__header`}>
            { poster && <div className={`${componentClass}__poster`} style={getBackgroundImg(getUploadedImagePath(poster))} /> }
            <img
                onClick={() => onPressPlay(0,0)}
                src={getUploadedImagePath(seriesImage)}
                alt={`${seriesTitle} :: QuistarGo.com`}
                className={`${componentClass}__musicCover`}
            />
            <div className={`${componentClass}__details`}>
                <h1>{ seriesTitle }</h1>
                { shortDescription && <p>{ shortDescription }</p> }
                <div className="buttons">
                    <button className="btn btn-white" onClick={() => onPressPlay(0,0)}>
                        <span>Play</span><i className="fa fa-play-circle-o" />
                    </button>
                    <button className="btn btn-outline-white"><span>Purchase</span><i className="fa fa-shopping-bag" /></button>
                </div>
            </div>
            <span className={`${componentClass}__fadedFoot`} />
        </div>
        <div className={`${componentClass}__content noPadding`}>
            <TabSlider tabs={buildTabs()} onChange={setActiveTab} activeKey={activeTab} />
            <TabSliderContent className={isLargeScreen ? "useInnerScroll" : ""} tabs={buildTabs()} activeKey={activeTab} />
        </div>
    </article> : <ContentNotFoundPage isProcessing={isProcessing} /> ;
};

export default ContentMusicPage;
